export type IAutolocateLocationFields = IDCA.IGenericFunc;

export function _autolocateLocationFields(): void {
  $('input.autolocate').each((_, field) => {
    const $longitudeInput = $(field);
    const longitudeInputName = $longitudeInput.attr('name') as string;
    const $latitudeInput = $(
      `input[name="${longitudeInputName.substring(0, longitudeInputName.indexOf('_long'))}_lat"]`
    );
    // If both fields are empty and navigator is avaiable trigger browser location
    if (!$longitudeInput.val() && !$longitudeInput.val() && 'geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        $longitudeInput.val(position.coords.longitude).trigger('change');
        $latitudeInput.val(position.coords.latitude).trigger('change');
      });
    }
  });
}
